import type { Router } from 'vue-router';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: (...args: unknown[]) => void;
  }
}

const SCRIPT_ID = 'meta-pixel-script';

const isPixelIdValid = (pixelId: string): boolean => /^\d{6,}$/.test(pixelId);

const bootstrapMetaPixel = (pixelId: string): boolean => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if (!isPixelIdValid(pixelId)) return false;

  if (!window.fbq) {
    const fbqStub = function (...args: unknown[]) {
      if (fbqStub.callMethod) {
        fbqStub.callMethod(...args);
      } else {
        fbqStub.queue.push(args);
      }
    } as {
      (...args: unknown[]): void;
      callMethod?: (...args: unknown[]) => void;
      queue: unknown[];
      loaded?: boolean;
      version?: string;
      push: (...args: unknown[]) => number;
    };

    fbqStub.queue = [];
    fbqStub.loaded = true;
    fbqStub.version = '2.0';
    fbqStub.push = (...args: unknown[]) => fbqStub.queue.push(args);

    window.fbq = fbqStub;
    window._fbq = fbqStub;
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';

    const firstScriptTag = document.getElementsByTagName('script')[0];
    if (firstScriptTag?.parentNode) {
      firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    } else {
      document.head.appendChild(script);
    }
  }

  window.fbq('init', pixelId);
  return true;
};

const trackPageView = () => {
  window.fbq?.('track', 'PageView');
};

export const trackMetaLead = () => {
  window.fbq?.('track', 'Lead');
};

export const setupMetaPixel = (router: Router, pixelId?: string) => {
  if (!pixelId) return;

  const initialized = bootstrapMetaPixel(pixelId);
  if (!initialized) return;

  void router.isReady().then(() => {
    trackPageView();
  });

  router.afterEach(() => {
    trackPageView();
  });
};
